import React from "react";
import { AddressElement } from "@stripe/react-stripe-js";
import useCustomerStore from "../store/customer-store";
import { sendGTMEvent } from "react-google-gtm";

const AddressForm: React.FC = () => {
  return (
    <>
      {/* <h3 className="mb-4 text-lg font-medium mt-4">Shipping Information</h3> */}
      <AddressElement
        options={{
          mode: "shipping",
          display: { name: "split" },
          fields: { phone: "always" },
          validation: { phone: { required: "always" } },
        }}
        onChange={(event) => {
          useCustomerStore.setState({
            firstName: event.value.firstName,
            lastName: event.value.lastName,
            phone: event.value.phone,
            address: {
              street: event.value.address.line1,
              city: event.value.address.city,
              postal_code: event.value.address.postal_code,
              state: event.value.address.state,
              country: event.value.address.country,
            },
          });
          sendGTMEvent({
            event: "checkout_step",
            firstname: event.value.firstName,
            lastname: event.value.lastName,
            phone: event.value.phone,
          });
        }}
      />
    </>
  );
};

export default AddressForm;
